import React from 'react';
import SectionHead from './SectionHead';
import useReveal from '../hooks/useReveal';

// HQ label coordinates are anchored to /app/frontend/public/assets/us_map_neon.webp
// The star pin baked into the image sits at ~(73.3%, 81.4%) of the asset.
const HQ_LEFT = '73.3%';
const HQ_TOP = '81.4%';

export default function ServiceArea() {
  const [mapRef, revealed] = useReveal(0.35);

  return (
    <section id="coverage" className="relative py-16 sm:py-20 lg:py-32 bg-black overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
        <SectionHead
          eyebrow="Delivery Options"
          title="We Deliver to the Lower 48"
        />

        {/* US Map + HQ label callout */}
        <div
          ref={mapRef}
          className="relative mt-12 sm:mt-16 lg:mt-20 flex justify-center"
          data-testid="coverage-map-wrapper"
        >
          <div className="relative w-full max-w-[1050px]">
            <img
              src="/assets/us_map_neon.webp"
              alt="Lower 48 delivery coverage map"
              className={`relative w-full h-auto object-contain select-none pointer-events-none transition-all duration-1000 ease-out ${
                revealed ? 'opacity-100 scale-100' : 'opacity-0 scale-[0.985]'
              }`}
              style={{ mixBlendMode: 'screen' }}
              data-testid="coverage-map-image"
            />

            {/* HQ callout — label + connector line pointing to the star baked into the map */}
            <div
              className="absolute pointer-events-none"
              style={{ left: HQ_LEFT, top: HQ_TOP }}
              data-testid="coverage-hq-pin"
            >
              <div className="hidden sm:flex absolute right-0 top-0 items-center -translate-y-1/2 flex-row-reverse">
                <span
                  className={`block mr-3 h-px bg-cyan-300/70 origin-right transition-all duration-700 ease-out ${
                    revealed ? 'w-10 sm:w-14 opacity-100' : 'w-0 opacity-0'
                  }`}
                  style={{ transitionDelay: revealed ? '900ms' : '0ms' }}
                />
                <span
                  className={`font-tech text-[9px] sm:text-[10px] tracking-[0.24em] uppercase text-cyan-200 whitespace-nowrap px-2 py-1 rounded-sm bg-black/70 border border-cyan-400/40 transition-all duration-700 ease-out ${
                    revealed ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2'
                  }`}
                  style={{ transitionDelay: revealed ? '1300ms' : '0ms' }}
                  data-testid="coverage-hq-label"
                >
                  HQ &middot; Fort Myers, FL
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
